import React, { Children } from 'react';
import * as PropTypes from 'prop-types';

const AccordionContainer = ({ children }) => {
  const accordions = Children.toArray(children);

  return <div className="accordion-container">{accordions}</div>;
};

AccordionContainer.propTypes = {
  children: PropTypes.node,
};

export default AccordionContainer;
